var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.items.length
    ? _c("div", { staticClass: "selected-filters mb-3" }, [
        _c(
          "button",
          {
            staticClass: "clear-filters-btn",
            on: {
              click: function($event) {
                return _vm.clearFilters()
              }
            }
          },
          [
            _c("font-awesome-icon", {
              staticClass: "icon",
              attrs: { icon: "ban" }
            }),
            _vm._v("Clear Filters\n  ")
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "ul",
          { staticClass: "selected-filters-list list-unstyled list-inline" },
          _vm._l(_vm.items, function(filter) {
            return _c(
              "li",
              {
                key: filter.id,
                staticClass: "filtered-item",
                attrs: { title: filter.category + ": " + filter.name },
                on: {
                  click: function($event) {
                    return _vm.removeItem(filter)
                  }
                }
              },
              [
                _vm._v("\n      " + _vm._s(filter.name) + "\n      "),
                _c("font-awesome-icon", {
                  staticClass: "icon",
                  attrs: { icon: "times", size: "sm", fixedWidth: "" }
                })
              ],
              1
            )
          }),
          0
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-50e30ee0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50e30ee0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SelectedFilters.vue
// module id = klEM
// module chunks = 1